"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HUDLED_EXPECTATIONS_MAP = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var CheckboxGroup_1 = __importDefault(require("shared/components/Form/CheckboxGroup"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var WizardParts_1 = require("./WizardParts");
var PREFIX = 'HudledExpectations';
var classes = {
    radioLabel: "".concat(PREFIX, "-radioLabel"),
    fullWidth: "".concat(PREFIX, "-fullWidth"),
};
var StyledStepTemplate = (0, styles_1.styled)(WizardParts_1.StepTemplate)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.radioLabel)] = {
            padding: theme.spacing(0.5, 0),
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: '10px',
            margin: theme.spacing(2, 0),
        },
        _b[".".concat(classes.fullWidth)] = {
            width: '100%',
        },
        _b);
});
exports.HUDLED_EXPECTATIONS_MAP = {
    spend: 'Find out how much we’re spending on software',
    track: 'Keep track of cost',
    reduce: 'Reduce my software cost',
    deals: 'Find special discounts and deals for software',
    feedback: 'Collect feedback from employees on software',
    licenses: 'Provisioning of licenses',
    usage: 'Understand usage',
};
var HUDLED_EXPECTATION_OPTIONS = (0, general_1.makeValueLabelArray)(interfaces_1.HUDLED_EXPECTATIONS, exports.HUDLED_EXPECTATIONS_MAP);
var FIELDS = ['hudledExpectations'];
var HudledExpectations = function () {
    var _a;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _b = __read((0, hooks_1.useSubmitter)('users', profile === null || profile === void 0 ? void 0 : profile.id), 1), profileSubmitter = _b[0];
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var submit = (0, utils_1.submitOnChange)(formValues.profile, profile, profileSubmitter, FIELDS);
    return ((0, jsx_runtime_1.jsx)(StyledStepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: !((_a = formValues.profile.hudledExpectations) === null || _a === void 0 ? void 0 : _a.length) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", height: "100%", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4 }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "My expectations are:" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2, pb: 4 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Choose all that apply" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 2 }, { children: (0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ component: "fieldset", className: classes.fullWidth }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "profile.hudledExpectations", component: CheckboxGroup_1.default, options: HUDLED_EXPECTATION_OPTIONS }) })) }))] })) })));
};
exports.default = HudledExpectations;
